




import { Component, Vue } from 'vue-property-decorator';
import { TokenExCvvContainerID } from '../lib/common/card-form/cardFormTypes';

@Component
export default class CoinflowCvvInput extends Vue {
  iframeId: string = TokenExCvvContainerID;
}
